'use client';

import { useSessionWarning } from '@/hooks/useSessionWarning';

export default function SessionWarning() {
  useSessionWarning();
  
  // 이 컴포넌트는 UI를 렌더링하지 않고 훅만 실행
  return null;
} 